/* eslint-disable react/prop-types */ // TODO: add props
import cameraHead from 'img/chunkview/camerahead.png';

export const ComingSoon = ({ lesson, coursePageUrl, mySubjectsUrl }) => {
  return (
    <div className="lesson-body">
      <h1>{lesson.get('title')}</h1>
      <div className="carousel modal-container">
        <div className="slides">
          <div className="slide">
            <div className="chunk-wrapper">
              <div className="chunk" id="empty-lesson">
                <div className="empty-lesson-content container clearfix">
                  <img src={cameraHead} />
                  <div className="instructions">
                    <h3>
                      We’re still working on this lesson. It’s coming soon
                      though. Promise!
                    </h3>
                    <p>
                      Maybe you’d like to
                      <a href={coursePageUrl}> view the available content </a>
                      within this course?
                    </p>
                    <p>
                      Or if not, feel free to go all the way back to
                      <a href={mySubjectsUrl}> your list of Edrolo courses.</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
